import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { LgdCheckboxComponent } from "./lgdCheckbox.component";

import { defineCheckboxComponent, defineTooltipComponent } from "@tylertech/forge";
import { ForgeModule } from "@tylertech/forge-angular";

defineCheckboxComponent();
defineTooltipComponent();

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ForgeModule,
    ],
    declarations: [LgdCheckboxComponent],
    exports: [
        ReactiveFormsModule,
        LgdCheckboxComponent
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LgdCheckboxModule { }
